import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormBaseClass } from '../shared/base-class/form-base-class';
import { FormGroup, FormControl, Validators, FormArray, ValidatorFn, FormBuilder } from '@angular/forms';
import { INFO_ICON } from '../../constant/common.constant';

export class CustomValidators {
  static multipleCheckboxRequireOne(fa: FormArray) {
    let valid = false;

    for (let x = 0; x < fa.length; ++x) {
      if (fa.at(x).value && fa.at(x).value.checked) {
        valid = true;
        break;
      }
    }
    return valid ? null : {
      multipleCheckboxRequireOne: true
    };
  }
}

@Component({
  selector: 'saeculum-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styleUrls: ['./checkbox-list.component.css']
})
export class CheckboxListComponent extends FormBaseClass implements OnInit, OnChanges {
  infoIcon = INFO_ICON.icon;
  @Input() fieldObj: any;
  @Input() options;
  @Input() values;
  @Input() form: FormGroup;
  @Output() valueChange = new EventEmitter<any>();
  constructor(public fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    this.addControl();
  }

  addControl() {
    this.form.addControl(this.fieldObj.key, new FormArray([],
      this.fieldObj.validators.required ? CustomValidators.multipleCheckboxRequireOne : null)
    );
    this.addCheckboxes();
  }

  getControls() {
    return (this.form.get(this.fieldObj.key) as FormArray).controls;
  }

  minSelectedCheckboxes(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        // get a list of checkbox values (boolean)
        .map(control => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => next ? prev + next : prev, 0);

      // if the total is not greater than the minimum, return the error message
      return totalSelected >= min ? null : { required: true };
    };

    return validator;
  }

  private addCheckboxes() {
    (this.fieldObj.options || []).forEach((item) => {
      (this.form.controls[this.fieldObj.key] as FormArray).push(this.initCheckbox(item));
    });
  }

  initCheckbox(value: any = {}): FormGroup {
    return this.fb.group({
      key: new FormControl(value.key),
      label: new FormControl(value.label),
      checked: new FormControl(value.checked || false),
    });
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.values && changes.values.currentValue && this.form.get(this.fieldObj.key)) {
      this.form.get(this.fieldObj.key).setValue(changes.values.currentValue);
    }
  }

  notifyChange(event) {
    this.valueChange.emit({ key: this.fieldObj.key, value: this.form.get(this.fieldObj.key).value });
  }

}
